/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
    cellContent,
    row,
    rowIndex,
    { openEditKurbanReportPage, allowEdit }
) => {
    return (
        <div className="d-flex flex-row justify-content-center align-items-center">
            <div className="">

            </div>
            {allowEdit && <OverlayTrigger
                overlay={<Tooltip id="kurbanReports-edit-tooltip">Lihat Detail</Tooltip>}
            >
                <Link to={`/kurban/report/${row.uuid}/detail`}>
                    <button
                        className="btn btn btn-light btn-hover-primary btn-sm mx-3"
                    >
                        Lihat Detail
                    </button>
                </Link>
            </OverlayTrigger>}
        </div>
    )
};
